import { Http } from '../../common/api';
import { SiteSettingspiConfiguration } from '../models';

export const siteSettingsHttp = new Http();

export const initializeSiteSettingsHttp = (config: SiteSettingspiConfiguration): void => {
  siteSettingsHttp.initializeHttp(config.baseUrl);
};
